'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidApps = function IoAndroidApps(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.5 13.8v-6.3h6.3v6.3h-6.3z m9.4 18.7v-6.2h6.2v6.2h-6.2z m-9.4 0v-6.2h6.3v6.2h-6.3z m0-9.4v-6.2h6.3v6.2h-6.3z m9.4 0v-6.2h6.2v6.2h-6.2z m9.4-15.6h6.2v6.3h-6.2v-6.3z m-9.4 6.3v-6.3h6.2v6.3h-6.2z m9.4 9.3v-6.2h6.2v6.2h-6.2z m0 9.4v-6.2h6.2v6.2h-6.2z' })
        )
    );
};

exports.default = IoAndroidApps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-apps.js
// module id = 1834
// module chunks = 0